"use client";

export default function Title({content, hilight}){

    return(
        <h2 className={"px-5 lg:px-0 text-2xl lg:text-5xl text-center"}>{content} <span className={"text-[#E6A900]"}>{hilight}</span></h2>
    )
}
